import { yupResolver } from '@hookform/resolvers/yup'
import { useState } from 'react'
import { useForm } from 'react-hook-form'

import { SetUserProfileRoute } from '../../../hooks/useUserProfileRoute'
import { InviteCreationStage, UserProfileScreens } from '../../../lib/types'
import { useUserProfileStore } from '../../../model/store'
import {
  type InviteCreationFormData,
  inviteCreationSchema
} from '../model/schemas'
import { InviteCreationConfirmationScreen } from './InviteCreationConfirmationScreen'
import { InviteCreationFailedScreen } from './InviteCreationFailedScreen'
import { InviteCreationForm } from './InviteCreationForm'
import { InviteCreationSucceedScreen } from './InviteCreationSucceedScreen'

type Props = {
  setUserProfileRoute: SetUserProfileRoute
}

export const InviteCreationScreen = ({ setUserProfileRoute }: Props) => {
  const [formData, setFormData] = useState<InviteCreationFormData>()

  const {
    inviteCreationStage: screen,
    setInviteCreationStage: setScreen,
    sentInvitePermissionsExpiresAt
  } = useUserProfileStore()

  const form = useForm<InviteCreationFormData>({
    resolver: yupResolver(inviteCreationSchema),
    defaultValues: inviteCreationSchema.getDefault(),
    mode: 'onSubmit',
    reValidateMode: 'onSubmit'
  })

  const personalAccountsError = form.formState.errors.personalAccounts?.message

  const onSubmit = (formData: InviteCreationFormData) => {
    setFormData(formData)
    setScreen(InviteCreationStage.Confirmation)
  }

  const goBack = () => {
    setUserProfileRoute(UserProfileScreens.Contacts)
  }

  return (
    <div className="flex h-full flex-col">
      {screen === InviteCreationStage.Confirmation && formData && (
        <InviteCreationConfirmationScreen inviteData={formData} />
      )}

      {screen === InviteCreationStage.Create && (
        <InviteCreationForm
          form={form}
          personalAccountsError={personalAccountsError}
          onSubmit={onSubmit}
        />
      )}

      {screen === InviteCreationStage.CreationSucceed && (
        <InviteCreationSucceedScreen
          goBack={goBack}
          permissionsExpiresAt={sentInvitePermissionsExpiresAt}
        />
      )}

      {screen === InviteCreationStage.CreationFailed && (
        <InviteCreationFailedScreen goBack={goBack} />
      )}
    </div>
  )
}
